import React from 'react';

import GetRate from './get-rate';
import ViewOrderDetails from './view-order-details';
import CreateNewOrder from './create-new-order';

const shipmentsGridHotkeys = [GetRate, ViewOrderDetails, CreateNewOrder];

const ShipmentsGridAdvancedHotkeys = ({ children, ...props }) => {
  return shipmentsGridHotkeys.reduce((acc, Hotkey) => <Hotkey {...props}>{acc}</Hotkey>, children);
};

export default ShipmentsGridAdvancedHotkeys;
